export const CUSTOMER_UTILITY_BILL_SIDEBAR = {
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)',
};
